// @core/api/endpoints/audittrail/list_audit_records.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAuditRecordsResponse,
} from '../../../types/audittrail';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/audittrail';

/**
 * List audit records
 * Returns audit records with filtering by date range, actor, resource, action type, and data classification. Supports pagination.
 */
export async function ListAuditRecords(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAuditRecordsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/audit/records`;
  const requestOptions = options;
  return client.get<ListAuditRecordsResponse>(requestPath, { ...requestOptions, params });
}
